// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"3cef8317","102":"a5c1c07c","121":"4524bf39","321":"cd484d66","417":"1e8e87a0","467":"addda60d","488":"eadfa0b8","601":"254ea931","653":"a7a90fa7","835":"a2bbc17a"}[chunkId] + ".chunk.js";
};